import type { Metadata } from "next";
import Keywords from "@/Component/Admin/Keyword";

export const metadata: Metadata = {
    title: "Keywords | Connector Club",
    description: "",
};

const KeywordsPage = () => {
    return (
        <Keywords />
    );
}

export default KeywordsPage;
